module.exports = __webpack_public_path__ + "images/moonshot/bc-sparkle.a2d5fa40765ab0f5e3c7.svg";